
import request from "@/utils/request.js";

// 获取oss地址
export  function getOss() {
  return   request({
    url: '/web/v1/index/oss/domain',
    method: 'get'
  })
}
// 请求banner
export function getBanner(query) {
    return request({
      url: '/web/v1/banner/banner',
      method: 'get',
      params: query
    })
}
// 联系我们
export function getContact(query) {
    return request({
      url: '/web/v1/index/contact/us',
      method: 'get',
      params: query
    })
}
// 查询首页
export function getIndex(query) {
    return request({
      url: '/web/v1/index/index',
      method: 'get',
      params: query
    })
}
// 获取网站信息
export function getSite(query) {
    return request({
      url: '/web/v1/index/site/info',
      method: 'get',
      params: query
    })
}
//走进瑞阳心语信息
export function getwalkIn(query) {
    return request({
      url: 'web/v1/walkIn/info',
      method: 'get',
      params: query
    })
}
//走进瑞阳心语列表
export function getwalkInList(query) {
    return request({
      url: '/web/v1/walkIn/page/list',
      method: 'get',
      params: query
    })
}
// 服务体系页面
export function getserviceSystem(query) {
    return request({
      url: '/web/v1/serviceSystem/index',
      method: 'get',
      params: query
    })
}
// 查询心智谷
export function getindustrySystem(query) {
    return request({
      url: '/web/v1/industrySystem/index/grain',
      method: 'get',
      params: query
    })
}
// 查询心理+
export function getindustrySystemAdd(query) {
    return request({
      url: '/web/v1/industrySystem/index/add',
      method: 'get',
      params: query
    })
}
// 查询心闻
export function getnewsMessage(query) {
    return request({
      url: '/web/v1/newsMessage/list',
      method: 'get',
      params: query
    })
}
// 文章管理
export function getArticle(id) {
    return request({
      url: `/web/v1/article/get/${id}`,
      method: 'get',
    })
}
// 获取天网
export function getskynet(query) {
    return request({
      url: `/web/v1/business_system/skynet`,
      method: 'get',
      query:query
    })
}
// 获取地网列表
export function getearthMatOne(query) {
    return request({
      url: `/web/v1/business_system/earthMatOne`,
      method: 'get',
      query:query
    })
}
// 获取人网
export function gethumanNetwork(query) {
    return request({
      url: `/web/v1/business_system/humanNetwork`,
      method: 'get',
      query:query
    })
}
// 获取人网
export function gethoaNet(query) {
    return request({
      url: `/web/v1/business_system/hoaNet`,
      method: 'get',
      query:query
    })
}
// 获取地网-心理装备
export function getequip(query) {
    return request({
      url: `/web/v1/business_system/earthMat/equip`,
      method: 'get',
      query:query
    })
}
// 获取地网-物理空间
export function getspace(query) {
    return request({
      url: `/web/v1/business_system/earthMat/space`,
      method: 'get',
      query:query
    })
}

// 獲取oss地址
export function getOssUrl() {
    return request({
        url: `/web/v1/index/oss/domain`,
        method: 'get',
    })
}
